import { useEffect, useState } from "react";
import { useUser } from "../../../contexts/UserContext";
import { BankAccount } from "../../types/banks/BankAccount";
import { FirestoreBankAccountRepository } from "../../../infrastructure/repositories/BankAccountRepository";

export function useBankAccounts() {
  const { appUser, loading: userLoading } = useUser();
  const [bankAccounts, setBankAccounts] = useState<BankAccount[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (userLoading) {
      return;
    }

    if (!appUser) {
      setLoading(false);
      return;
    }

    const repository = new FirestoreBankAccountRepository();

    const unsubscribe = repository.observeBankAccountsByAppUserId(
      appUser.appUserId,
      (accounts) => {
        setBankAccounts(accounts);
        setLoading(false);
      },
      (err) => {
        console.error("Error fetching bank accounts:", err);
        setError(err);
        setLoading(false);
      },
    );

    return () => unsubscribe();
  }, [appUser, userLoading]);

  return { bankAccounts, loading, error };
}
